import {
  getContentProps,
  getImageUrl,
  I_ContentMeta,
} from '../../common/state/apiGet';
import {I_ApiMeta} from '../../common/util/api';
import {toCamelCase} from '../../common/util/string';
import {ISearchCategory, ISearchGenre, ISearchResult} from '../type';

export function getGenres(data: I_SearchGenre[] = []): ISearchGenre[] {
  return data.map(genre => ({
    name: genre.title,
    bgImg: getImageUrl(genre.contentView?.backgroundSearchThumbnailImage),
    thumbImg: getImageUrl(
      genre.contentView?.featuredCharacterSearchThumbnailImageA,
      {
        hasAlpha: true,
      }
    ),
  }));
}

export function getResult(
  data: I_SearchResult,
  meta: I_ApiMeta
): ISearchResult {
  return {
    contents: getResultContents(data.content),
    totalCount: meta.pagination?.totalCount || 0,
  };
}

function getResultContents(data: I_SearchContent[] = []) {
  return data.map(content => ({
    ...getContentProps(content, [
      'id',
      'sid',
      'title',
      'thumbImg',
      'titleImg',
      'badges',
      'bgImg',
      'authors',
      'mainImg',
      'mainTitleImg',
    ]),
    genre: content.genre,
    searchCategory: toCamelCase(content.searchCategory) as ISearchCategory,
  }));
}

interface I_SearchGenre {
  title: string;
  contentView: {
    backgroundSearchThumbnailImage: string;
    featuredCharacterSearchThumbnailImageA: string;
  };
}

export interface I_SearchResult {
  content: I_SearchContent[];
}

interface I_SearchContent extends I_ContentMeta {
  searchCategory: 'CONTENT' | 'GENRE' | 'AUTHOR';
  genre: string;
}
